import { render, staticRenderFns } from "./ModalTutoUnsubscribe.vue?vue&type=template&id=0dfb29e2&scoped=true&"
import script from "./ModalTutoUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./ModalTutoUnsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./ModalTutoUnsubscribe.vue?vue&type=style&index=0&id=0dfb29e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfb29e2",
  null
  
)

component.options.__file = "ModalTutoUnsubscribe.vue"
export default component.exports